"use strict";

exports.__esModule = true;
exports.InstantaneousEventTicketsWithComments = exports.InstantaneousEventTickets = exports.InstantaneousEventHistoricalPartCountShift = exports.InstantaneousEventHistoricalPartCount = exports.InstantaneousEventComments = exports.InstantaneousEventAuditLogs = exports.InstantaneousEventAlerts = exports.EventTimelineController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _queryString = require("query-string");
var _AsyncLoader = require("../../Core/AsyncLoader");
var _RestAPI = require("../../API/RestAPI");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Utils = require("../../../Utils");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _Translator = require("../../Core/Translator");
var _fetchAlertPages = require("../../Core/DataTable/fetchAlertPages");
var _UI = require("../../../Utils/UI");
var _TicketingContext = require("../../Ticketing/TicketingContext");
var _excluded = ["content"];
var _dec, _dec2, _dec3, _dec4, _class, _EventTimelineController;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var InstantaneousEventTicketsWithComments = exports.InstantaneousEventTicketsWithComments = "TicketsWithComments";
var InstantaneousEventTickets = exports.InstantaneousEventTickets = "Tickets";
var InstantaneousEventAlerts = exports.InstantaneousEventAlerts = "Alerts";
var InstantaneousEventComments = exports.InstantaneousEventComments = "Comments";
var InstantaneousEventAuditLogs = exports.InstantaneousEventAuditLogs = "AuditLogs";
var InstantaneousEventHistoricalPartCount = exports.InstantaneousEventHistoricalPartCount = "HistoricalPartCount";
var InstantaneousEventHistoricalPartCountShift = exports.InstantaneousEventHistoricalPartCountShift = "HistoricalPartCountShift";
function stringifyDevices(deviceList) {
  return deviceList.join(";");
}
function stringifyStartEnd(start, end, seperator) {
  if (seperator === void 0) {
    seperator = ";";
  }
  return "" + start + seperator + end;
}
function formatQuery(_ref) {
  var devices = _ref.devices,
    type = _ref.type,
    start = _ref.start,
    end = _ref.end,
    number = _ref.number,
    size = _ref.size,
    sort = _ref.sort,
    searchTerm = _ref.searchTerm,
    skipCount = _ref.skipCount;
  var query = {};
  if (searchTerm && searchTerm.length > 0) {
    // ToDo: this is not currently implemented on any service but adding in for completeness
    query.searchTerm = searchTerm;
  }
  if (number !== undefined) {
    query.page = number;
  }
  if (size !== undefined) {
    query.size = size;
  }
  if (skipCount) {
    query.skipCount = true;
  }
  if (sort && sort.length > 0) {
    // example ["deviceId:desc", "createdDate:asc"]
    query.sort = sort.map(function (colSort) {
      return colSort.property + ":" + colSort.direction.toLowerCase();
    });
  }

  // TODO:: Refactor svc's to accept queries with same param name
  if (type === InstantaneousEventComments) {
    query.deviceUuid = stringifyDevices(devices);
  } else if (type === InstantaneousEventAlerts) {
    query.device = devices;
  } else if (type === InstantaneousEventAuditLogs) {
    delete query.device;
  } else {
    query.deviceUuids = stringifyDevices(devices);
  }
  if (type === InstantaneousEventAlerts || type === InstantaneousEventAuditLogs) {
    query.start = start;
    query.end = end;
  } else {
    query.overlapping = stringifyStartEnd(start, end, type === InstantaneousEventComments ? "/" : ";");
  }
  if (type === InstantaneousEventTicketsWithComments) {
    query.comments = true;
  }
  return query;
}

/**
 * Fetches Instantaneous Events for the given devices and start-end date range
 */
var EventTimelineController = exports.EventTimelineController = (_dec = _RestAPI.RestAPIContext.withContext, _dec2 = _DeviceListContext.AllEnabledDeviceListContext.withContext, _dec3 = _DataAccessorContext.DataAccessorContext.withContext, _dec4 = _TicketingContext.TicketingContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_EventTimelineController = /*#__PURE__*/function (_Component) {
  function EventTimelineController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      handleReload: undefined
    };
    _this.setReloadState = function (reload) {
      _this.setState({
        handleReload: reload
      });
    };
    _this.getAllAlerts = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(query) {
        var dataAccessor, _yield$fetchAlertPage, rows, truncated, _this$context, translate, message;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              dataAccessor = _this.props.dataAccessor;
              _context.n = 1;
              return (0, _fetchAlertPages.fetchAlertPages)(function (page, size) {
                return dataAccessor.getAlerts(formatQuery(Object.assign({}, query, {
                  type: InstantaneousEventAlerts,
                  number: page,
                  size: size,
                  skipCount: true
                })));
              });
            case 1:
              _yield$fetchAlertPage = _context.v;
              rows = _yield$fetchAlertPage.rows;
              truncated = _yield$fetchAlertPage.truncated;
              if (truncated) {
                translate = (_this$context = _this.context) == null ? void 0 : _this$context.translate;
                message = "This chart draws only the first alerts of the period. The period has more.";
                (0, _UI.showWarningToaster)(translate ? translate("EventTimeline.Alerts.truncated", message) : message);
              }
              return _context.a(2, {
                content: rows
              });
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.getRequest = function (type) {
      var _this$props = _this.props,
        api = _this$props.api,
        dataAccessor = _this$props.dataAccessor,
        deviceList = _this$props.deviceList,
        allEnabledDevices = _this$props.allEnabledDevices,
        start = _this$props.start,
        end = _this$props.end,
        pagination = _this$props.pagination,
        sortOrder = _this$props.sortOrder,
        searchTerm = _this$props.searchTerm;
      var validDevices = (0, _Utils.getValidDeviceList)(deviceList, allEnabledDevices.map(function (device) {
        return device.uuid;
      }));
      var areAllDevicesSelected = allEnabledDevices.length === validDevices.length;
      var devices = areAllDevicesSelected ? validDevices.length === 1 ? validDevices : [] : validDevices;
      var query = Object.assign({
        devices: devices,
        // for all devices just send nothing as this is essentially a filter
        start: start,
        end: end,
        searchTerm: searchTerm
      }, pagination, {
        sort: sortOrder
      });

      /* SMELL:: InstantaneousEventTicketsWithComments is a smell.
                 comments = true should be a configuration not a separate InstantaneousEvent.
         TODO:: Refactor the EventTimelineController to allow to take the extra query for each dataSource
       */

      switch (type) {
        case InstantaneousEventTickets:
          return api.get("/api/v1/ticketing/ticket?" + (0, _queryString.stringify)(formatQuery(Object.assign({}, query, {
            type: InstantaneousEventTickets
          }))));
        case InstantaneousEventTicketsWithComments:
          return api.get("/api/v1/ticketing/ticket?" + (0, _queryString.stringify)(formatQuery(Object.assign({}, query, {
            type: InstantaneousEventTicketsWithComments
          }))));
        case InstantaneousEventAlerts:
          // A caller that pages (the grid) gets one page with its count. One that
          // sets no pagination draws every alert, so it reads every page.
          if (pagination) {
            return dataAccessor.getAlerts(formatQuery(Object.assign({}, query, {
              type: InstantaneousEventAlerts
            })));
          }
          return _this.getAllAlerts(query);
        case InstantaneousEventComments:
          return dataAccessor.getComments(query);
        case InstantaneousEventAuditLogs:
          return dataAccessor.getAuditLogs(formatQuery(Object.assign({}, query, {
            type: InstantaneousEventAuditLogs
          })));
        case InstantaneousEventHistoricalPartCount:
          var formattedQuery = formatQuery(query);
          return dataAccessor.getHistoricalPartCountData({
            dateFrom: query.start,
            dateTo: query.end,
            page: query.number,
            pageSize: query.size,
            devices: query.devices,
            searchTerm: formattedQuery.searchTerm,
            sort: formattedQuery.sort
          });
        case InstantaneousEventHistoricalPartCountShift:
          return dataAccessor.getHistoricalPartCountShiftData({
            dateFrom: query.start,
            dateTo: query.end,
            devices: query.devices
          });
        default:
          return null;
      }
    };
    _this.load = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var eventTypes, events, pagination, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            eventTypes = _this.props.eventTypes;
            _context2.n = 1;
            return Promise.all(eventTypes.map(_this.getRequest).filter(function (req) {
              return !!req;
            }));
          case 1:
            events = _context2.v;
            pagination = {};
            data = eventTypes.reduce(function (acc, type, idx) {
              var response = events[idx];
              var _ref4 = response || {},
                content = _ref4.content,
                paginationParams = _objectWithoutPropertiesLoose(_ref4, _excluded);

              // empty array or default to content (paged response) else assume the response is an array of data
              var data = response ? content || response : [];
              acc[type] = data.map(function (event) {
                return Object.assign({}, event, {
                  created: event.created || event.createdAt || ((event == null ? void 0 : event.createdMillis) != null ? new Date(event.createdMillis).toISOString() : null),
                  icon: type + "Icon"
                });
              });

              // Add pagination data
              if (response && response.totalElements !== undefined) {
                pagination = paginationParams;
              }
              return acc;
            }, {});
            return _context2.a(2, Object.assign({}, data, {
              pagination: pagination
            }));
        }
      }, _callee2);
    }));
    _this.shouldReloadTickets = function (prevProps) {
      return prevProps.ticketing.lastCreatedTicket !== _this.props.ticketing.lastCreatedTicket && _this.props.eventTypes.some(function (d) {
        return [InstantaneousEventTickets, InstantaneousEventTicketsWithComments].includes(d);
      });
    };
    return _this;
  }
  _inheritsLoose(EventTimelineController, _Component);
  var _proto = EventTimelineController.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.shouldReloadTickets(prevProps) && this.state.handleReload) {
      this.state.handleReload();
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      children = _this$props2.children,
      eventTypes = _this$props2.eventTypes,
      start = _this$props2.start,
      end = _this$props2.end,
      deviceList = _this$props2.deviceList,
      pagination = _this$props2.pagination,
      onData = _this$props2.onData,
      sortOrder = _this$props2.sortOrder;
    return /*#__PURE__*/_react["default"].createElement(_AsyncLoader.AsyncLoader, {
      load: this.load,
      params: {
        eventTypes: eventTypes,
        start: start,
        end: end,
        deviceList: deviceList,
        pagination: pagination,
        sortOrder: sortOrder
      },
      onData: onData,
      setReload: this.setReloadState
    }, function (data) {
      return children(data);
    });
  };
  return EventTimelineController;
}(_react.Component), _EventTimelineController.contextType = _Translator.TranslatorContext, _EventTimelineController.defaultProps = {
  allEnabledDevices: undefined,
  api: undefined,
  dataAccessor: undefined,
  ticketing: undefined
}, _EventTimelineController)) || _class) || _class) || _class) || _class);